import styled, { createGlobalStyle } from 'styled-components';

// 消息类型
export type MessageType = 'success' | 'error' | 'warning' | 'info';

// 全局样式 - 重置 Ant Design Message 样式
export const MessageGlobalStyle = createGlobalStyle`
  /* 重置 Ant Design message 容器样式 */
  .ant-message {
    top: 20px !important;
    pointer-events: none;
    position: fixed !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    width: auto !important;
    /* 提示需压过全屏浮层（画布灯箱 / 导演台等 z-index 10000 级），否则挂在 body 上会被遮住 */
    z-index: 11001 !important;
    text-align: center !important;
  }

  /* 关键修复：覆盖所有状态下的样式，包括动画过程中 */
  .custom-message-container.ant-message-notice,
  .custom-message-container.ant-message-notice.ant-move-up-leave,
  .custom-message-container.ant-message-notice.ant-move-up-leave-active {
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    border: none !important;
    border-radius: 0 !important;
    margin: 0 auto !important;
    pointer-events: auto;
    display: inline-block !important;
  }

  .custom-message-container .ant-message-notice-content,
  .custom-message-container .ant-message-notice.ant-move-up-leave .ant-message-notice-content,
  .custom-message-container .ant-message-notice.ant-move-up-leave-active .ant-message-notice-content {
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    border: none !important;
    border-radius: 0 !important;
    margin: 0 !important;
    display: block !important;
  }

  /* 隐藏 Ant Design 默认图标，保留自定义图标 */
  .custom-message-container.ant-message-notice > .anticon {
    display: none !important;
  }

  /* 确保自定义组件图标正常显示 */
  .custom-message-container .anticon {
    display: inline-block !important;
    width: 22px !important;
    height: 22px !important;
    font-size: 22px !important;
    line-height: 1 !important;
  }

  .custom-message-container .anticon svg {
    width: 22px !important;
    height: 22px !important;
    display: block !important;
  }
`;

// 消息容器样式
export const MessageContainer = styled.div<{ $type: MessageType }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 152px;
  height: 42px;
  flex-shrink: 0;
  border-radius: 32px;
  /* 深色底与全局弹窗（下拉/菜单/工具条）风格统一（20261103 主公定稿） */
  background: #2c2c2c;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.6);
  position: relative;
  z-index: 10000;
  white-space: nowrap;
  padding: 0 16px;
  gap: 8px;

  /* 响应式宽度 */
  min-width: 152px;
  width: auto;
  max-width: 1000px;
`;

// 图标容器样式
export const MessageIcon = styled.div<{ $type: MessageType }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  font-size: 22px;
  overflow: visible;

  .anticon {
    width: 22px !important;
    height: 22px !important;
    font-size: 22px !important;
    line-height: 1 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    color: ${props => {
      switch (props.$type) {
        case 'success':
          return '#52c41a';
        case 'error':
          return '#ff4d4f';
        case 'warning':
          return '#faad14';
        default:
          return '#1890ff';
      }
    }};

    svg {
      width: 22px !important;
      height: 22px !important;
      display: block !important;
      overflow: visible !important;
    }
  }
`;

// 文字样式
export const MessageText = styled.span`
  color: #fff;
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  white-space: nowrap;
`;
